// extracted by mini-css-extract-plugin
export var compact = "_n9-2";
export var phoneFrame = "_n9-0";
export var phoneScreen = "_n9-1";